import themeGet from '@styled-system/theme-get';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider, createGlobalStyle } from 'styled-components/macro';
import reset from 'styled-reset';

import { ThemeProvider as DSThemeProvider } from '@olist/design-system';
import { UnitedGlobalStyle, theme } from '@olist/united';

import GlobalAlert from '../components/alert/global-alert';
import AlertProvider from '../contexts/alert-context';
import { configInterceptors } from '../helpers/http-client';
import i18nNext from '../helpers/i18n-next';

configInterceptors();

export const GlobalStyle = createGlobalStyle`
  ${reset}

  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    font-family: ${themeGet('font')};
    line-height: 1.5;
  }

  b { font-weight: bold; }

  button { font-family: ${themeGet('font')}; }
`;

const AllProviders = ({ children }: any) => (
  <AlertProvider>
    <I18nextProvider i18n={i18nNext}>
      <ThemeProvider theme={theme}>
        <DSThemeProvider>
          <UnitedGlobalStyle />
          <GlobalStyle />
          <GlobalAlert>{children}</GlobalAlert>
        </DSThemeProvider>
      </ThemeProvider>
    </I18nextProvider>
  </AlertProvider>
);

export default AllProviders;
